import type { HybrisMunicipalityUnit } from '../../models/hybris/hybrisMunicipalityUnit';

import getDirectHybrisAxiosClient from '../clients/directHybrisAxiosClient';

export const municipalityDirectApiUrls = {
    getMunicipalityUnit: (municipalityId: string, unitId: string) =>
        `/municipality/${municipalityId}/units/${unitId}`,
} satisfies {
    [k in keyof typeof municipalityDirectApi]: `/${string}` | ((...args: string[]) => `/${string}`);
};

export const municipalityDirectApi = {
    getMunicipalityUnit:
        (spaToken: string) => async (params: { municipalityId: string; unitId: string }) => {
            const response = await getDirectHybrisAxiosClient(spaToken).get<HybrisMunicipalityUnit>(
                municipalityDirectApiUrls.getMunicipalityUnit(params.municipalityId, params.unitId),
            );
            return response && response.data;
        },
};
